import React from 'react'

import { RendaFixa } from 'suno-calcs'
import 'suno-calcs/dist/index.css'

const App = (props) => {
  return (
  <>
    <div style={style.sunofit}>
      <div style={style.card}>
        <RendaFixa title={props.title} value={props.subtitle} />
      </div>
    </div>
  </>
  )
}

const style = {
  sunofit:{
    margin: '2%'
  },
  card:{
    borderRadius:'8px',
    boxShadow:'0.3rem 0.3rem 1rem rgba(0,0,0,0.25)',
    maxWidth: '780px',
  }
}
export default App
